import header from '../_modules/header/index.js'
import { handleRefsUs, REFS_US } from '@studybay/common-client-library/ref-handle'
import { revealLinksOnAction } from "../_modules/helpers";

function handleSpecialitiesModals() {
    const typesModal = document.querySelector('[data-js="types-modal"]')
    const subjectsModal = document.querySelector('[data-js="subjects-modal"]')
    const showSubjectsButton = document.querySelector('[data-js="show-subjects"]')
    const showTypesButton = document.querySelector('[data-js="show-types"]')
    const closeModalElements = document.querySelectorAll('[data-js="modal-cancel"]')

    if (!closeModalElements.length) return

    closeModalElements.forEach(closeElement => {
        const modal = closeElement.closest('.modal')
        closeElement.addEventListener('click', () => {
            modal.hidden = true
            document.body.style.overflow = 'unset'
        })
    })

    if (showSubjectsButton) {
        showSubjectsButton.addEventListener('click', () => {
            subjectsModal.hidden = false
            document.body.style.overflow = 'hidden'
            subjectsModal.querySelector('button,input').focus()
        })

        const areasTogglers = document.querySelectorAll('[name="spec-area-select"]')
        if (areasTogglers.length < 1) return

        const subjectsLists = document.querySelectorAll('[data-js|="spec-area-list"]')

        areasTogglers.forEach(toggler => {
            toggler.addEventListener('click', () => {
                subjectsLists.forEach(list => list.hidden = true)
                const listToRevealNumber = toggler.value
                const list = document.querySelector(`[data-js="spec-area-list-${listToRevealNumber}"]`)
                if (list) list.hidden = false
            })
        })
    }


    if (showTypesButton) showTypesButton.addEventListener('click', () => {
        typesModal.hidden = false
        document.body.style.overflow = 'hidden'
        typesModal.querySelector('button,input').focus()
    })
}

function handleFastReg() {
    const hireButton = document.querySelector('[data-js="hire-expert"]')
    if (!hireButton) return

    const fastRegModal = document.querySelector('[data-js="fastreg-modal"]')
    const authorIdInput = document.getElementById('authorId')
    const fastregCancelElements = document.querySelectorAll('[data-js="fastreg-cancel"]')
    const fastregError = fastRegModal.querySelector('[data-js="fastreg-error"]')
    const fastregForm = fastRegModal.querySelector('form')
    const fastregEmailInput = fastRegModal.querySelector('[type="email"]')
    const fastregSubmit = fastRegModal.querySelector('form button')

    const setError = error => fastregError.innerHTML = error
    const isErrorSet = () => Boolean(fastregError.innerHTML)
    const resetError = () => isErrorSet() && (fastregError.innerHTML = '')
    const setLoadTriggerDisabled = (element, disabled, busy) => {
        element.disabled = disabled
        element.setAttribute('tabindex', disabled ? -1 : 0)
        element.setAttribute('aria-busy', Boolean(disabled && busy))
    }
    const openFastregModal = () => {
        fastRegModal.hidden = false
        document.body.style.overflow = 'hidden'
        authorIdInput.value = window.A24.Profile.userId
        fastregEmailInput.focus()
    }

    hireButton.addEventListener('click', openFastregModal)

    fastregCancelElements.forEach(element => {
        element.addEventListener('click', () => {
            fastRegModal.hidden = true
            document.body.style = {}
        })
    })
    fastregEmailInput.addEventListener('change', resetError)

    fastregForm.addEventListener('submit', (e) => {
        e.preventDefault()

        const email = fastregEmailInput.value
        const isEmailValid = /\S+@\S+\.\S+/.test(email)
        if (!isEmailValid) return setError('Invalid email')

        const body = new FormData()
        body.append('email', email)
        setLoadTriggerDisabled(fastregSubmit, true, 'submitFastreg')

        fetch('/ajax/checkEmail', {
            method: 'POST',
            body,
            headers: {'x-requested-with': 'XMLHttpRequest'},
        })
            .then(res => res.json())
            .then(data => {
                if (Number(data.count) === 0) return e.target.submit()
                setError('This email is already registered')
            })
            .catch(error => console.warn(`Couldn't verify email. Error: ${error}`))
            .finally(() => setLoadTriggerDisabled(fastregSubmit, false))
    })
}

function handleReviewsLoad() {
    let start = 16
    let offset = 10
    let type = 0
    let category = 0
    const userId = window.A24.Profile.userId
    let areAllReviewsLoaded = false

    const reviewsList = document.querySelector('[data-js="reviews-list"]')
    const moreReviews = document.querySelector('[data-js="more-reviews"]')
    const searchForm = document.querySelector('#reviews-filter')
    const noReviewsAlert = document.querySelector('#no-reviews')
    const moreButton = document.querySelector('#more-reviews-button')

    if (!moreReviews) return

    const insertLoadedReviews = (reviews) => {
        if (!reviews.length) {
            if (!reviewsList.children.length) noReviewsAlert.hidden = false
            moreButton.hidden = true
        } else {
            noReviewsAlert.hidden = true
            moreButton.hidden = false
        }

        for (const review of reviews) {
            const reviewCard = `
                <img width="32" height="32" src="${review.avatar}" alt="" class="review__avatar">
                <div class="review__info">
                    <div class="review__left">
                        <span class="review__user">${review.customer_nick}</span>
                        <span class="review__date">${review.date}</span>
                    </div>
                    <div class="review__statistics">
                        Review ${Number(review.grade) === 0 ? '👍' : '👎'} <span class="separator">|</span> Deadline
                            ${Number(review.deadline_type) === 1 ? `
                                <svg width="16" height="16" fill="none" viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg">
                                    <title>On Time</title>
                                    <circle cx="9.5" cy="9.5" r="9.5" fill="#00C471"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9.557 3a.52.52 0 01.394.19.705.705 0 01.163.458v6.747l3.617 2.403a.647.647 0 01.251.392.74.74 0 01-.055.484.579.579 0 01-.331.301.488.488 0 01-.418-.053l-3.897-2.59a.61.61 0 01-.206-.237A.73.73 0 019 10.77V3.648c0-.172.059-.337.163-.458A.52.52 0 019.557 3z" fill="#fff" stroke="#fff"/>
                                </svg>` : `
                                <svg width="16" height="16" fill="none" viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg">
                                    <title>Delayed</title>
                                    <circle cx="9.5" cy="9.5" r="9.5" fill="#FF6B6B"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9.557 3a.52.52 0 01.394.19.705.705 0 01.163.458v6.747l3.617 2.403a.647.647 0 01.251.392.74.74 0 01-.055.484.579.579 0 01-.331.301.488.488 0 01-.418-.053l-3.897-2.59a.61.61 0 01-.206-.237A.73.73 0 019 10.77V3.648c0-.172.059-.337.163-.458A.52.52 0 019.557 3z" fill="#fff" stroke="#fff"/>
                                </svg>
                            ` }
                    </div>
                    <p class="p review__comment">${review.comment}</p>
                </div>
            `

            const reviewElement = document.createElement('li')
            reviewElement.className = 'review'
            reviewElement.innerHTML = reviewCard

            reviewsList.append(reviewElement)
        }
    }

    const setLoading = loading => {
        moreReviews.disabled = false
        moreReviews.classList[loading ? 'add' : 'remove']('loading')
        reviewsList.setAttribute('aria-busy', loading)
        moreReviews.setAttribute('aria-busy', loading)
        moreReviews.setAttribute('tabindex', loading ? -1 : 0)
        moreReviews.disabled = loading
    }

    const postReviewsLoad = (reviews) => {
        // loaded all reviews
        areAllReviewsLoaded = reviews.length < offset
        start += offset
        return reviews
    }

    const loadingOver = () => {
        setLoading(false)
        moreReviews.hidden = areAllReviewsLoaded
    }

    const loadReviews = (isFirst=false) => {
        offset = isFirst ? 15 : 10
        if (isFirst) start = 1

        const form = new FormData()
        form.append('start', start)
        form.append('cnt', offset)
        if (+type) form.append('type', type)
        if (+category) form.append('category', category)
        form.append('user_id', userId)

        setLoading(true)

        fetch('/ajax/getrateworklist', {
            method: 'post',
            body: form,
            headers: { 'x-requested-with': 'XMLHttpRequest' },
        })
            .then(res => res.json())
            .then(postReviewsLoad)
            .then(insertLoadedReviews)
            .catch(error => `Error while loading reviews for author ${userId}. ${error}`)
            .finally(loadingOver)
    }

    const loadMore = () => loadReviews(false)

    const searchReviews = (e) => {
        e.preventDefault()

        reviewsList.innerHTML = ''

        type = searchForm.elements['type_id'].value || 0
        category = searchForm.elements['category_id'].value || 0

        loadReviews(true)
    }

    moreReviews.addEventListener('click', loadMore)
    searchForm.addEventListener('submit', searchReviews)
}

handleFastReg()
handleSpecialitiesModals()
handleReviewsLoad()
header()
revealLinksOnAction(handleRefsUs.bind(null, REFS_US.SEO_US_AUTHORS))
